import React from 'react'

import About from './About.jsx'

export default () => (
  <About id='about2'>
    いろんなところでインターン・アルバイトするのがすきです。
  </About>
)
